import { useContext } from 'react';
import { getDayjsDate, formatDateByPreferences } from "../FormattedDate/util";
import LocalizationContext from "../LocalizationProvider/LocalizationContext";
import { dateToFromNow } from "../utils/commonUtility";
import getDateFormat from "../FormattedDate/getDateFormat";

function createFormattedDate(date, format, preferences, isEnglish) {
  var dayjsDate = getDayjsDate(date, format);
  var dateFormat = format === 'time' ? 'LT' : getDateFormat(format, isEnglish);
  var dateString = format === 'humanized' ? dateToFromNow(dayjsDate, isEnglish) : formatDateByPreferences(dayjsDate, dateFormat, preferences);
  return dayjsDate.isValid() ? dateString : 'Invalid date';
}

export var useFormattedDate = function useFormattedDate(date, format) {
  var _useContext = useContext(LocalizationContext),
      isEnglish = _useContext.isEnglish,
      preferences = _useContext.preferences;

  return createFormattedDate(date, format, preferences, isEnglish);
};
export var useFormattedDatesArray = function useFormattedDatesArray(dates, format) {
  var _useContext2 = useContext(LocalizationContext),
      isEnglish = _useContext2.isEnglish,
      preferences = _useContext2.preferences;

  return dates.map(function (date) {
    return createFormattedDate(date, format, preferences, isEnglish);
  });
};